/* ErrorScreen.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ErrorScreen.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl-next';
import { LinkButton } from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import Link from '@atlaskit/link';
import { ConfluenceLogo } from '@atlaskit/logo';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { Stack, Text, Box } from '@atlaskit/primitives/compiled';
import { ExperienceContext, ExperienceTrackerContext } from '@atlassian/experience-tracker';
import { ExperienceReasons } from '../experience-tracker/ExperienceNames';
import { LoginToConfluenceIcon } from '../assets/LoginPageIconSVG';
import messages from './messages';
var LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES = 'https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-browser-cookies/';
var containerStyles = null;
export var ErrorScreen = function ErrorScreen(_ref) {
  var standaloneConfluenceUrl = _ref.standaloneConfluenceUrl;
  var experienceTracker = useContext(ExperienceTrackerContext);
  var experience = useContext(ExperienceContext);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  useEffect(function () {
    experienceTracker.abort({
      name: experience,
      reason: ExperienceReasons.UNABLE_TO_DISPLAY_CONTENT
    });
  }, [experience, experienceTracker]);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "error-screen-container",
    className: ax(["_11c82smr _19pk1wug _2hwx1wug _otyr1wug _18u01wug _4cvr1h6o _1e0c1txw _2lx21bp4 _4t3idgin _1bah1b1v _kqswh2mm _y3gn1h6o"])
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.300",
    alignInline: "center"
  }, /*#__PURE__*/React.createElement(ConfluenceLogo, {
    appearance: "brand",
    size: "xlarge"
  }), /*#__PURE__*/React.createElement(LoginToConfluenceIcon, null), /*#__PURE__*/React.createElement(Heading, {
    as: "div",
    size: "xlarge"
  }, formatMessage(messages.paragraphLogin))), /*#__PURE__*/React.createElement(Box, {
    paddingBlockStart: 'space.300',
    paddingBlockEnd: 'space.150'
  }, /*#__PURE__*/React.createElement(LinkButton, {
    appearance: "primary",
    "aria-label": formatMessage(messages.buttonLoginToConfluenceNewTab),
    iconAfter: LinkExternalIcon,
    href: standaloneConfluenceUrl !== null && standaloneConfluenceUrl !== void 0 ? standaloneConfluenceUrl : '',
    target: "_blank"
  }, formatMessage(messages.buttonLoginToConfluenceNewTab))), /*#__PURE__*/React.createElement(Stack, {
    space: "space.150"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, formatMessage(messages.paragraphAlreadyLoggedIn)), /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, formatMessage(messages.paragraphStillHavingTrouble, {
    link: /*#__PURE__*/React.createElement(Link, {
      href: LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES,
      target: "_blank",
      "aria-label": formatMessage(messages.linkAriaLabel)
    }, formatMessage(messages.linkTroubleshootingText))
  }))));
};